export async function contactUsPublic(apiInstance, data) {
  try {
    const response = await apiInstance.post(`/Public/contactus`, data);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

export async function fetchFilterResults(apiInstance, data) {
  try {
    const response = await apiInstance.get(`/Public/leaderboard${data}`);
    return response.data;
  } catch (err) {
    throw err.response
      ? err.response.data
      : new Error("Error fetching results");
  }
}

export async function fetchPublicEvents(apiInstance) {
  try {
    const response = await apiInstance.get(`/Public/search-event`);
    return response.data;
  } catch (err) {
    throw err.response
      ? err.response.data
      : new Error("Error fetching results");
  }
}

//service for search event public
export async function searchEventPublic(apiInstance, query) {
  try {
    const response = await apiInstance.get(`/Public/search-event?q=${query}`);
    return response.data;
  } catch (err) {
    throw err.response
      ? err.response.data
      : new Error("An error occurred while searching for events");
  }
}

// SERVICES FOR RESET  Password
export async function sendResetPasswordEmail(apiInstance, email) {
  try {
    const response = await apiInstance.post(
      `/User/send-resetpassword-email/${email}`,
    );
    return response;
  } catch (err) {
    return err;
  }
}

export async function verifyResetPassword(apiInstance, accessCode, email) {
  try {
    await apiInstance.get(`/User/verify-reset-password/${accessCode}/${email}`);
  } catch (err) {
    throw err.response ? err.response.data : new Error("Verification failed.");
  }
}

export async function resetPassword(apiInstance, accessCode, email, password) {
  try {
    const response = await apiInstance.put(`/User/reset-password`, {
      accessCode,
      email,
      password,
    });
    return response.data;
  } catch (err) {
    throw err.response
      ? err.response.data
      : new Error("An error occurred while resetting the password");
  }
}
